import {getUserIdentity} from 'src/components/api/interface-hhy';
import {weChatJsSdkSign} from 'src/components/api/interface-gateway';
import {randomString} from 'src/components/api/utils';
import store from 'src/config/store.config';

let wxHideMenuPromise = null;
let wxHideMenuRouteKey = '';

/**
 * 1. 通过config接口注入权限验证配置
 * 所有需要使用JS-SDK的页面必须先注入配置信息，否则将无法调用
 *
 * 2. config信息验证后会执行ready方法，
 * 所有接口调用都必须在config接口获得结果之后，
 * config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。
 * 对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
 *
 * 3.config信息验证失败会执行error函数，
 * 如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
 */
export function wxConfig () {
  let clientUrl = window.location.href.split('#')[0],
    stamp = ((new Date()).getTime() / 1000) | 0,
    nonce = randomString(16);
  return new Promise((resolve, reject) => {
    if (store.state.wxJsApiConfigStatus === true) {
      resolve('success');
      return;
    }
    weChatJsSdkSign({
      clientUrl: clientUrl,
      stamp,
      nonce
    }).then(res => {
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: getUserIdentity('appId'), // 必填，公众号的唯一标识
        timestamp: stamp, // 必填，生成签名的时间戳
        nonceStr: nonce, // 必填，生成签名的随机串
        signature: res, // 必填，签名
        jsApiList: ['scanQRCode', 'updateAppMessageShareData', 'closeWindow', 'hideOptionMenu'] // 必填，需要使用的JS接口列表
      });
      wx.ready(function () {
        store.commit('setWxJsApiConfigStatus', true);
        resolve('success');
      });
      wx.error(function(res) {
        console.error('微信config验证失败', res);
        store.commit('setWxJsApiConfigStatus', false);
        reject(res);
      });
    }).catch(error => {
      store.commit('setWxJsApiConfigStatus', false);
      reject(error);
    });
  });
}

/**
 * 禁用微信右上角菜单（全页面禁用分享）
 * @return {Promise}
 */
export function wxDisableShareMenu () {
  const routeKey = window.location.href;
  if (wxHideMenuRouteKey === routeKey) {
    return Promise.resolve('success');
  }
  if (wxHideMenuPromise) {
    return wxHideMenuPromise;
  }
  wxHideMenuPromise = new Promise((resolve) => {
    wxConfig().then(() => {
      if (typeof wx === 'undefined' || typeof wx.hideOptionMenu !== 'function') {
        wxHideMenuPromise = null;
        resolve('unsupported');
        return;
      }
      wx.hideOptionMenu({
        success: function () {
          wxHideMenuRouteKey = routeKey;
          resolve('success');
        },
        fail: function (err) {
          console.error('微信禁用右上角菜单失败', err);
          resolve('fail');
        },
        complete: function () {
          wxHideMenuPromise = null;
        }
      });
    }).catch(err => {
      console.error('微信禁用分享菜单失败', err);
      wxHideMenuPromise = null;
      resolve('fail');
    });
  });
  return wxHideMenuPromise;
}
/**
 * 微信扫一扫
 * @return {Promise}
 */
export function wxScan () {
  return new Promise((resolve, reject) => {
    wxConfig().then(res => {
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ['qrCode'], // 可以指定扫二维码还是一维码，默认二者都有
        success: function (res) {
          let result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
          resolve(result);
        },
        error: function (res) {
          reject(res);
        }
      });
    }).catch(err => {
      reject(err);
    });
  });
}

/**
 * 分享：自定义“分享给朋友”及“分享到QQ”按钮的分享内容
 * @return {Promise}
 */
export function wxUpdateAppMessageShareData (params) {
  return new Promise((resolve, reject) => {
    wxConfig().then(res => {
      wx.updateAppMessageShareData({
        ...params,
        success: function () {
          resolve('success')
        },
        fail: function (err) {
          reject(err);
        }
      });
    }).catch(err => {
      reject(err);
    });
  });
}

/**
 * 关闭当前网页窗口
 */
export function wxCloseWindow () {
  wxConfig().then(res => {
    wx.closeWindow();
  }).catch(err => {
    console.error(err);
  });
}



// WEBPACK FOOTER //
// ./src/components/api/weixin-jsapi.js